import { memo } from "react";

import { Colors, type Status, type TagProps } from "@snapchat/snap-design-system";

import { DetailsTag } from "./DetailsTag";
import { Visible } from "./Visible";

type LensTagStatus = Extract<"info" | "error", Status>;

const CustomStatusColor: Record<LensTagStatus, string> = {
    info: Colors.Blue.V100,
    error: Colors.Red.V100,
};

interface LensTagProps extends TagProps {
    status: LensTagStatus;
    show?: boolean;
}

export const LensTag = memo<LensTagProps>(({ children, status, show = true }) => (
    <Visible when={show}>
        <DetailsTag status={status} color={CustomStatusColor[status]}>
            {children}
        </DetailsTag>
    </Visible>
));
